import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import * as debug from 'debug';
import { ToolsProvider } from '../../providers/tools/tools';
import { ConfigProvider } from '../../providers/config/config';

@Component({
  selector: 'home-fabs',
  templateUrl: 'home-fabs.html',
})
export class HomeFabsComponent {
  log = debug('app:HomeFabsComponent');

  @ViewChild('buttonsWrapper') buttonsWrapper;
  @Input() showAll = true;
  @Input() hideButtons = true;
  @Input() moveFabsUp = false;
  @Output() emitCreate = new EventEmitter();
  @Input() largeFabs = false;
  buttons = [];

  constructor(public tools: ToolsProvider, public configs: ConfigProvider) {}

  ngOnInit() {
    this.buttons = this.configs.get('home-lc-fabs');
  }

  ngOnChanges() {
    this.scrollToEnd();
  }

  scrollToEnd() {
    setTimeout(() => {
      try {
        const width = this.buttonsWrapper?.nativeElement?.scrollWidth;
        this.log('buttonsWrapper', width);
        this.buttonsWrapper?.nativeElement?.scrollTo(width, 0);
      } catch (e) {}
    });
  }

  navToPage(e, button) {
    try {
      e.preventDefault();
      e.stopPropagation();
    } catch (e) {}
    this.tools.navTo(button?.page, button?.tab, button?.params || {});
  }
}



// WEBPACK FOOTER //
// ./src/components/home-fabs/home-fabs.ts